export const AUTH_HEADER = 'x-fp-authorization';
export const ONBOARDING_CONFIG_KEY_HEADER = 'X-Onboarding-Config-Key';
